/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _7 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>7 - Redux DevTools</h2>
    <p className={styles.description}>
      Чтобы упростить работу с Redux существуют Redux DevTools. Они помогают отслеживать изменение состояния с течением
      времени, наблюдать за отправкой дейтсвий и т. п. Естеcтвенно, это предназначено только для разработки.{' '}
    </p>
    <a className={styles.link} href="https://www.npmjs.com/package/redux-devtools-extension" target="_blank">
      Документация redux-devtools-extension{' '}
    </a>
  </section>
))
